(() => {
  if (window.leavysCollectionMeasurement) return;
  const version = '1';
  const measurementId = 'G-5VGX1MYPG2';
  const queueKey = 'leavys_collection_outbox_v1';
  const diagnosticsRequested = new URL(location.href).searchParams.get('ls_collection_test') === '1';
  const testDeliveryRequested = new URL(location.href).searchParams.get('ls_collection_send_test') === '1';
  const defaultSort = document.querySelector('script[data-collection-default-sort]')?.dataset.collectionDefaultSort || 'created-descending';
  const events = [];
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  const gridRoot = () => document.querySelector('leavys-results[data-nf-list-id="womens"]');
  const isPreview = () => gridRoot()?.dataset.nfPreview !== 'false';
  let root = null, observer = null, states = new Map(), generation = 0, signature = '';
  let pending = [], loaded = false, flushing = false, panel = null;
  window.leavysCollectionMeasurement = {version, events};

  function persist() {
    if (!allowed()) return;
    try { sessionStorage.setItem(queueKey, JSON.stringify(pending.map(({sent, ...row}) => row))); } catch {}
  }
  function diagnostic() {
    if (!isPreview() || !diagnosticsRequested || !gridRoot()) return;
    if (!panel) {
      panel = document.createElement('details');
      panel.id = 'leavys-collection-test';
      panel.style.cssText = 'position:fixed;bottom:90px;left:12px;z-index:2147483646;max-width:min(430px,90vw);max-height:45vh;overflow:auto;background:#fff;color:#173e32;border:2px solid #173e32;border-radius:12px;padding:12px;font:14px/1.5 system-ui;box-shadow:0 4px 20px #0002';
      const heading = document.createElement('summary');
      heading.textContent = 'Collection measurement preview';
      panel.append(heading, document.createElement('p'), document.createElement('pre'));
      const privacyButton = document.createElement('button');
      privacyButton.type = 'button';
      privacyButton.textContent = 'Cookie preferences';
      privacyButton.addEventListener('click', () => window.privacyBanner?.showPreferences?.());
      panel.append(privacyButton);
      panel.querySelector('pre').style.cssText = 'white-space:pre-wrap;font:12px/1.4 monospace';
      document.body.append(panel);
    }
    panel.querySelector('p').textContent = `${events.filter(e => e.name === 'view').length} product views · ${events.filter(e => e.name === 'click').length} product clicks. ${testDeliveryRequested ? (allowed() ? 'Analytics test delivery enabled; marked test.' : 'Analytics test paused: consent required.') : 'Preview only: no analytics sent.'}`;
    panel.querySelector('pre').textContent = events.slice(-4).map(e => `${e.name}: ${e.ls_collection_product}\nPosition ${e.ls_collection_position.replace('pos_', '')} · ${e.ls_collection_state}`).join('\n\n');
  }
  function identity() {
    return new Promise(resolve => {
      if (typeof window.gtag !== 'function') return resolve(null);
      const result = {};
      const timer = setTimeout(() => resolve(null), 1000);
      const finish = () => {if (result.client_id && result.session_id) {clearTimeout(timer); resolve(result);}};
      window.gtag('get', measurementId, 'client_id', value => {result.client_id = value; finish();});
      window.gtag('get', measurementId, 'session_id', value => {result.session_id = value; finish();});
    });
  }
  async function flush() {
    if (flushing || !allowed() || !pending.some(row => !row.sent)) return;
    flushing = true;
    try {
      const ids = await identity();
      if (!ids || !allowed()) return;
      for (const row of pending.filter(row => !row.sent && row.created > Date.now() - 120000)) {
        if (!allowed() || typeof window.Shopify?.analytics?.publish !== 'function') break;
        await window.Shopify.analytics.publish(`leavys_collection:${row.name}`, {...row.data,
          ga_client_id: String(ids.client_id), ga_session_id: String(ids.session_id), tracking_event_id: row.id});
        row.sent = true;
      }
    } catch {} finally {flushing = false;}
  }
  function emit(name, data) {
    const preview = root?.dataset.nfPreview !== 'false';
    if ((!preview || testDeliveryRequested) && !allowed()) return;
    const payload = {...data, environment: testDeliveryRequested ? 'test' : preview ? 'preview' : 'live', ls_tracking_mode: testDeliveryRequested ? 'test' : 'live', page_path: location.pathname};
    if (preview) {
      events.push({name, ...payload});
      if (events.length > 200) events.shift();
      diagnostic();
      if (!testDeliveryRequested) return;
    }
    const id = window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    pending = pending.filter(row => row.created > Date.now() - 120000).concat({id, name, data:payload, created:Date.now()}).slice(-160);
    persist();
    flush();
  }
  function context(card) {
    const url = new URL(location.href);
    const filtered = [...url.searchParams.keys()].some(key => key.startsWith('filter.') && key !== 'filter.v.availability') || url.searchParams.has('ls_style');
    const sort = root.querySelector('[name="sort_by"]')?.value || url.searchParams.get('sort_by') || defaultSort;
    const sorted = sort !== defaultSort;
    const cards = [...root.querySelectorAll('[data-nf-grid] > [data-product-id]')];
    return {
      ls_collection_id: root.dataset.nfListId,
      ls_collection_product: `p_${card.dataset.productId}`,
      ls_collection_position: `pos_${(Number(url.searchParams.get('page') || 1) - 1) * 24 + cards.indexOf(card) + 1}`,
      ls_collection_state: filtered ? (sorted ? 'filtered_sorted' : 'filtered') : (sorted ? 'sorted' : 'default')
    };
  }
  function permitted() {return document.visibilityState !== 'hidden' && ((root?.dataset.nfPreview !== 'false' && !testDeliveryRequested) || allowed());}
  function view(card, reason) {
    const state = states.get(card);
    if (!state || state.viewed || !card.isConnected || card.hidden || !permitted() || root.getAttribute('aria-busy') === 'true') return false;
    state.viewed = true;
    emit('view', {...context(card), exposure_reason: reason});
    return true;
  }
  function cancel(state) {clearTimeout(state.timer); state.timer = null;}
  function begin(card, state) {
    if (!state.visible || state.viewed || state.timer || !permitted()) return;
    const token = generation;
    state.timer = setTimeout(() => {
      state.timer = null;
      if (token === generation && state.visible) view(card, 'visible_500ms');
    }, 500);
  }
  function observe() {
    const next = gridRoot();
    if (!next || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?collections\//i.test(location.pathname) || !window.IntersectionObserver) return;
    const url = new URL(location.href);
    const criteria = [...url.searchParams].filter(([key]) => key.startsWith('filter.') || ['sort_by','page','per_page','ls_style','view'].includes(key)).sort().map(pair => pair.join('=')).join('&');
    const nextSignature = criteria + '|' + [...next.querySelectorAll('[data-nf-grid] > [data-product-id]')].map(card => card.dataset.productId).join(',');
    if (root === next) {
      for (const [card, state] of states) begin(card, state);
      return;
    }
    const retained = nextSignature === signature ? new Map([...states].map(([card, state]) => [card.dataset.productId, state])) : new Map();
    for (const state of states.values()) cancel(state);
    observer?.disconnect();
    root = next; generation++; signature = nextSignature; states = new Map();
    observer = new IntersectionObserver(entries => {
      for (const entry of entries) {
        const state = states.get(entry.target);
        if (!state) continue;
        state.visible = entry.isIntersecting && entry.intersectionRatio >= 0.5;
        if (state.visible) begin(entry.target, state); else cancel(state);
      }
    }, {threshold:[0,0.5]});
    for (const card of root.querySelectorAll('[data-nf-grid] > [data-product-id]')) {
      if (!/^\d+$/.test(card.dataset.productId)) continue;
      const saved = retained.get(card.dataset.productId);
      states.set(card, {viewed: saved?.viewed || false, clicked: saved?.clicked || false, visible:false, timer:null});
      observer.observe(card);
    }
    diagnostic();
  }
  function start() {
    if (allowed() && !loaded) {
      loaded = true;
      try {pending = JSON.parse(sessionStorage.getItem(queueKey) || '[]').filter(row => row.created > Date.now()-120000).slice(-160);} catch {pending = [];}
    }
    observe();
    flush();
  }
  function click(event) {
    if (event.type === 'click' && event.button !== 0 || event.type === 'auxclick' && event.button !== 1) return;
    const link = event.target.closest('a[href]');
    const card = link?.closest('[data-nf-grid] > [data-product-id]');
    if (!card || !states.has(card) || !permitted() || root.getAttribute('aria-busy') === 'true') return;
    const target = new URL(link.href, location.href);
    if (target.origin !== location.origin || !target.pathname.includes('/products/')) return;
    const state = states.get(card);
    if (state.clicked) return;
    if (!state.viewed) view(card, 'clicked_before_500ms');
    if (!state.viewed) return;
    state.clicked = true; cancel(state);
    emit('click', context(card));
  }
  document.addEventListener('click', click, {capture:true});
  document.addEventListener('auxclick', click, {capture:true});
  document.addEventListener('leavys:filters-rendered', observe);
  document.addEventListener('visibilitychange', () => {
    for (const [card, state] of states) {if (document.visibilityState === 'hidden') cancel(state); else begin(card, state);}
  });
  window.addEventListener('pagehide', () => {for (const state of states.values()) cancel(state);});
  window.addEventListener('pageshow', start);
  document.addEventListener('visitorConsentCollected', () => {
    if (allowed()) start();
    else {
      pending = []; loaded = false;
      try {sessionStorage.removeItem(queueKey);} catch {}
      for (const state of states.values()) {cancel(state); state.viewed = false; state.clicked = false;}
    }
    diagnostic();
  });
  if (!window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.2'}], start);
  start();
  let retries = 0;
  const retry = setInterval(() => {start(); if (++retries >= 15) clearInterval(retry);}, 1000);
})();
